/** "ON_LEAVE" / "WORKED" / "general" -> "On Leave" / "Worked" / "General". */
export const humanizeEnum = (value: string | null | undefined): string => {
    if (!value) return '';
    return value
        .replace(/[_\s]+/g, ' ')
        .trim()
        .toLowerCase()
        .replace(/\b\w/g, c => c.toUpperCase());
};
